export default __webpack_public_path__ + "static/media/purpleCard.a61d5f25.svg";